module.exports = __webpack_public_path__ + "img/mongodb.2765b371.svg";